import { render, staticRenderFns } from "./profileBinding.vue?vue&type=template&id=4d1d4735&"
import script from "./profileBinding.vue?vue&type=script&lang=js&"
export * from "./profileBinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports